let isPersonalAutoFunc;
let isHomeOwnerFunc;
let isPersonalUmbrellaFunc;

const productOrder = {
    PersonalAuto: 0,
    HOPDwelling: 1,
    HOPRental: 2,
    HOPCondo: 3,
    HOPLandlordHome: 4,
    HOPLandlordCondo: 5,
    HOPDefault: 6,
    PersonalUmbrella: 7
};

const getProductWeight = (submission) => {
    if (!isPersonalAutoFunc || !isHomeOwnerFunc || !isPersonalUmbrellaFunc) {
        console.error(new Error('SortSubmissionService: Compare functions are not initialized!'));
    }
    if (isPersonalAutoFunc(submission)) {
        return productOrder.PersonalAuto;
    }
    if (isHomeOwnerFunc(submission)) {
        const productType = submission.productType || submission.coveragePartType || submission.product.coveragePartType_ML;
        switch (productType) {
            case 'hopdwelling':
                return productOrder.HOPDwelling;
            case 'hoprental':
                return productOrder.HOPRental;
            case 'hopcondo':
                return productOrder.HOPCondo;
            case 'hop_landlord_home_ml':
                return productOrder.HOPLandlordHome;
            case 'hop_landlord_condo_ml':
                return productOrder.HOPLandlordCondo;
            default:
                return productOrder.HOPDefault;
        }
    }
    if (isPersonalUmbrellaFunc(submission)) {
        return productOrder.PersonalUmbrella;
    }
};

export default {
    sortSubmissions: (submissions, isPersonalAuto, isHomeOwner, isPersonalUmbrella) => {
        isPersonalAutoFunc = isPersonalAuto;
        isHomeOwnerFunc = isHomeOwner;
        isPersonalUmbrellaFunc = isPersonalUmbrella;

        submissions.sort((a, b) => getProductWeight(a) - getProductWeight(b));
    }
};
